//
//
//
//
//
//
//
//
//
//
//

import MHeader from '../Header/Header.vue';
import SearchInput from '../SearchInput/SearchInput.vue';
export default {
    data() {
        return {}
    },
    methods: {

    },
    components: {
        MHeader,
        SearchInput
    },
    computed: {}
}



// WEBPACK FOOTER //
// ./src/components/HomeSearch/HomeSearch.vue